<template>
  <div class="home">
    <el-dialog :title="$t('other.a1804')" :visible.sync="SecondPWSVisible" width="30%">
      <p style="line-height:30px">{{$t('other.a1807')}}</p>
      <el-input type="password" v-model="secondPws" :placeholder="$t('other.a1808')"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SecondPWSVisible = false">{{$t('other.a106')}}</el-button>
        <el-button type="primary" @click="setSecondPWS()">{{$t('other.a279')}}</el-button>
      </span>
    </el-dialog>
    <div v-if="!show">
      <div
        style="width:100%;display: flex;flex-direction: column;justify-content: center;margin-top: 225px;align-items: center;"
      >
        <h3 @click="ingknv()">{{$t('home.secondPwsTip')}}</h3>
        <span style="cursor: pointer;color: #007EE5;padding:10px 0" @click="gotopersonal()">{{$t('other.a1809')}}</span>
        <div class="not-edit-all">
          <div class="edit-item">
            <el-input
              ref="mark"
              size="mini"
              v-model="kilogram"
              type="password"
              @keyup.enter.native="comfirm"
              :placeholder="$t('home.secondPwsInput')"
            ></el-input>
            <el-button
              ref="btn"
              size="mini"
              style="margin-left: 10px;"
              type="primary"
              @click="comfirm"
            >{{$t('home.confirm')}}</el-button>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="home-box">
      <!-- <Dialog :Claimpopup.sync="Claimpopup" :claimdatatype='claimdatatype' @updataPage="updataPage"></Dialog> -->
      <div>
        <div class="home-title">
          <div style="display: flex;font-size:18px;align-items:center">
            <div class="block">
              <el-date-picker
                v-model="value4"
                type="datetimerange"
                :picker-options="pickerOptions2"
                :range-separator="$t('other.a47')"
                :start-placeholder="$t('other.a45')"
                :end-placeholder="$t('other.a46')"
                @change="getSalesBytime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                align="right"
              ></el-date-picker>
            </div>
          </div>
          <div>
            <div v-if="!hasSecPw">
              <el-button
                style="margin: 0 10px"
                size="medium"
                type="primary"
                @click="SecondPWSVisible=true"
              >{{$t('other.a1804')}}</el-button>
              <el-tooltip
                style="font-size:24px"
                effect="light"
                :content="$t('other.a1805')"
                placement="bottom-start"
              >
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
            <div v-else>
              <el-button style="margin-right:30px" type="primary" @click="closePage()">退 出</el-button>
            </div>
          </div>
        </div>

        <div class="ilnkg">
          <div class="klnf">
            {{$t('other.a1810')}}
            <el-button
              type="primary"
              size="mini"
              @click="openexch"
              style="margin-left:30px"
            >{{$t('processed.Checkcurrency')}}</el-button>
          </div>
          <div class="home-box-ttp">
            <div class="home-box-item">
              <div class="item-header">
                <div>
                  <span style="cursor: pointer;padding-right:10px">{{$t('home.allshop')}}</span>
                </div>
                <div style="display: flex;cursor: pointer;">
                  <div class="item-header-right">{{$t('processed.summary')}}</div>
                  <el-tooltip
                    effect="light"
                    :content="$t('processed.local')"
                    placement="bottom-start"
                  >
                    <div class="item-header-right01">?</div>
                  </el-tooltip>
                </div>
              </div>
              <div class="item-content">
                <span style="font-size: 28px;">￥{{turnover}}</span>
                <span style="font-size: 18px;">{{$t('home.sale')}}</span>
                <span
                  style="font-size: 14px;margin-top: 10px;color: rgba(50,50,50,.6);"
                >{{$t('home.tip1')}}</span>
              </div>
              <div class="item-footer">
                <div>{{orderItemCount}}</div>
                <div style="font-size: 18px;padding: 5px 0;">{{$t('home.quantity')}}</div>
              </div>
            </div>
            <div class="home-box-item">
              <div class="item-header">
                <div>
                  <span style="padding-right:15px">{{$t('home.grossprofit')}}</span>
                </div>
                <div style="display: flex;">
                  <div class="item-header-right">{{$t('processed.summary')}}</div>
                  <el-tooltip effect="light" :content="$t('processed.localt')" placement="bottom">
                    <div class="item-header-right01">?</div>
                  </el-tooltip>
                </div>
              </div>
              <div class="item-content">
                <span style="font-size: 28px;">￥{{getnum(profit)}}</span>
                <span style="font-size: 18px;">{{$t('home.grossprofit')}}</span>
                <span
                  style="font-size: 14px;margin-top: 10px;color: rgba(50,50,50,.6);"
                >{{$t('home.tip2')}}</span>
              </div>
              <div class="item-footer">
                <div>{{getnum(interest)}}%</div>
                <div style="font-size: 18px;padding: 5px 0;">{{$t('home.grossmargin')}}</div>
              </div>
            </div>
            <div class="home-box-item">
              <div class="item-header">
                <div>
                  <span style="padding-right:15px">{{$t('home.allstorehuozhi')}}</span>
                </div>
                <div style="display: flex;cursor: pointer;">
                  <div class="item-header-right">{{$t('processed.summary')}}</div>
                  <el-tooltip effect="light" :content="$t('processed.localth')" placement="bottom">
                    <div class="item-header-right01">?</div>
                  </el-tooltip>
                </div>
              </div>
              <div class="item-content">
                <span style="font-size: 28px;">￥{{housevalue}}</span>
                <span style="font-size: 18px;">{{$t('home.houzhi')}}</span>
                <span
                  style="font-size: 14px;margin-top: 10px;color: rgba(50,50,50,.6);"
                >{{$t('home.tip3')}}</span>
              </div>
              <div class="item-footer">
                <div>￥{{deliveryfee}}</div>
                <div style="font-size: 18px;padding: 5px 0;">{{$t('home.shipingcost')}}</div>
              </div>
            </div>
          </div>
          <div class="jlknkg">
            <div class="skilk" v-for="(item,index) in integralData" :key="index ">
              <div style="font-size:20px">{{item.changeIntegral}} {{$t('other.a54')}}</div>
              <div class="lknl">{{payType[item.payType]}}</div>
            </div>
          </div>
        </div>
        <Inventory />
        <!-- //商店/shops-销售状况 -->
        <div class="shop-sales">
          <div class="shop-sales-header">
            <div
              style="padding: 0px 15px 0 0;font-size: 18px;font-weight: bold;"
            >{{$t('home.allshopsales')}}</div>
          </div>

          <div class="shop-sales-content">
            <el-table :data="inventoryData" border style="width: 100%">
              <el-table-column :label="$t('processed.shopName')" prop="shopId">
                <template slot-scope="props">{{showshopNameByshopIdOne(props.row.shopId)}}</template>
              </el-table-column>
              <el-table-column :label="$t('processed.country')" prop="country">
                <template slot-scope="props">{{tabletype[props.row.country]}}</template>
              </el-table-column>
              <el-table-column :label="$t('processed.platform')" prop="platform"></el-table-column>
              <el-table-column sortable :label="$t('processed.advCost')" prop="advCost">
                <template slot-scope="props">￥{{getnum(props.row.advCost)}}</template>
              </el-table-column>
              <el-table-column sortable :label="$t('processed.turnover')" prop="turnover">
                <template slot-scope="props">￥{{getnum(props.row.turnover)}}</template>
              </el-table-column>

              <el-table-column sortable :label="$t('processed.returnAmount')" prop="returnAmount">
                <template slot-scope="props">￥{{getnum(props.row.returnAmount)}}</template>
              </el-table-column>
              <el-table-column sortable :label="$t('processed.orderCount')" prop="orderCount"></el-table-column>
              <el-table-column sortable :label="$t('other.a1806')" prop="Tol_PerforMancd">
                <template slot-scope="props">{{props.row.Tol_PerforMancd.escrowAmount}}</template>
              </el-table-column>
              <el-table-column
                sortable
                :label="$t('processed.orderItemCount')"
                prop="orderItemCount"
              ></el-table-column>
              <el-table-column sortable :label="$t('processed.outboundCount')" prop="outboundCount"></el-table-column>
              <el-table-column
                sortable
                :label="$t('processed.outboundItemCount')"
                prop="outboundItemCount"
              ></el-table-column>
              <el-table-column sortable :label="$t('processed.shipCost')" prop="shipCost">
                <template slot-scope="props">￥{{getnum(props.row.shipCost)}}</template>
              </el-table-column>
              <el-table-column sortable :label="$t('processed.costCount')" prop="costCount">
                <template slot-scope="props">￥{{getnum(props.row.costCount)}}</template>
              </el-table-column>

              <el-table-column :label="$t('processed.operation')">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="chartopen(scope.$index, scope.row)"
                  >{{$t('processed.chart')}}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 仓库-库存状况 -->
        <div class="shop-sales">
          <div class="shop-sales-header">
            <div
              style="padding: 15px 0;font-size: 18px;font-weight: bold;"
            >{{$t('processed.Warehousestatus')}}</div>
          </div>
          <div class="shop-sales-content">
            <el-table :data="warehouseSales" border style="width: 100%">
              <el-table-column :label="$t('processed.storeid')" prop="store_id"></el-table-column>
              <el-table-column :label="$t('processed.storeName')" prop="storeName"></el-table-column>
              <el-table-column sortable :label="$t('processed.volume')" prop="volume">
                <template slot-scope="props">{{getnum(props.row.volume)}}</template>
              </el-table-column>
              <el-table-column sortable :label="$t('processed.cost')" prop="COST">
                <template slot-scope="props">{{getnum(props.row.COST)}}</template>
              </el-table-column>
              <el-table-column sortable :label="$t('processed.unshipped')" prop="unshipped"></el-table-column>
              <el-table-column sortable :label="$t('processed.skunum')" prop="sku_num"></el-table-column>
              <el-table-column sortable :label="$t('processed.storenum')" prop="store_num"></el-table-column>
              <el-table-column sortable :label="$t('processed.weight')" prop="weight">
                <template slot-scope="props">{{getnum(props.row.weight)}}</template>
              </el-table-column>
              <el-table-column sortable :label="$t('processed.auditedstock')" prop="audited_stock"></el-table-column>
            </el-table>
          </div>
        </div>

        <!-- <div><svg id="barcode"></svg></div> -->
        <el-dialog
          :title="$t('processed.chart')"
          :visible.sync="chartstaus"
          width="60%"
          :before-close="chartstauscolse"
        >
          <span
            style="font-size:20px"
          >{{$t('processed.temporalinterval')}}：{{this.value4[0]}}~~{{this.value4[1]}}</span>
          <div id="categoryPortraitEchart" style="width:800px;height:520px"></div>
        </el-dialog>
        <!-- //商店拆线图 -->
        <el-dialog
          :title="shopName + '-' + $t('home.tipdialog')"
          :visible.sync="salesVisible"
          width="50%"
        >
          <div class="wrapper-box">
            <div :id="shopName" class="line-box"></div>
          </div>

          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="salesVisible=false">{{$t('home.close')}}</el-button>
          </span>
        </el-dialog>

        <!-- //仓库拆线图 -->
        <el-dialog
          :title="storeName +'-' + $t('home.tipdialog')"
          :visible.sync="salesVisible01"
          width="50%"
        >
          <div class="wrapper-box">
            <div :id="storeName" class="line-box"></div>
          </div>

          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="salesVisible01=false">{{$t('home.close')}}</el-button>
          </span>
        </el-dialog>
      </div>

      <el-dialog
        :title="$t('processed.exchangerate')"
        :modal="false"
        :visible.sync="dialogVisible_dd"
        width="70%"
        :before-close="handleClose_dd"
      >
        <el-table :data="tableData" border height="400" style="width: 100%">
          <el-table-column :label="$t('processed.country')" prop="country">
            <template slot-scope="props">{{tabletype[props.row.country]}}</template>
          </el-table-column>
          <el-table-column :label="$t('processed.currency')" prop="currency"></el-table-column>
          <el-table-column sortable :label="$t('processed.exchangerate')" prop="rate"></el-table-column>

          <el-table-column :label="$t('processed.operation')">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="handleEdit(scope.$index, scope.row)"
              >{{$t('processed.Modifyrate')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible_dd = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="dialogVisible_dd = false">{{$t('other.a279')}}</el-button>
        </span>-->
      </el-dialog>

      <el-dialog
        :title="$t('processed.Modifyrate')"
        :modal="false"
        :visible.sync="dialogVisible_hy"
        width="50%"
        :before-close="handleClose_hy"
      >
        <span
          style="font-size:16px;font-weight:bold;"
        >{{$t('processed.country')}}:{{tabletype[country]}}</span>
        <span
          style="margin-left:30px;font-size:16px;font-weight:bold;"
        >{{$t('processed.currency')}}:{{currency}}</span>
        <span
          style="margin-left:30px;font-size:16px;font-weight:bold;"
        >{{$t('processed.latestcurrency')}}:{{rate}}</span>
        <el-input
          v-model="input"
          :placeholder="$t('processed.newexchange')"
          style="margin-top:20px"
        ></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closedisid">{{$t('processed.cancel')}}</el-button>
          <el-button type="primary" @click="closedis">{{$t('processed.confirm')}}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import JsBarcode from "jsbarcode";
import { mapState, mapActions, mapMutations } from "vuex";
// import Dialog from '../components/dialog/dialog.vue'
// import echarts from 'echarts';
import api from "../../api/moudles/shopaccess";
import Point_api from "../../api/moudles/deduction";
import echarts from "echarts";
import utils from "../../utils/utils.js";
import { timeSpanNoValid } from "../../utils/toolFun";
import Inventory from "./inventoryRp";

export default {
  data() {
    return {
      servie: false,
      one: "",
      two: "",
      three: "",
      four: "",
      five: "",
      six: "",
      seven: "",
      payType: {
        "0": this.$t("processed.wechat"),
        "1": this.$t("processed.Wechatincome"),
        "2": this.$t("processed.alipay"),
        "3": this.$t("processed.Alipayincome"),
        "4": this.$t("processed.Spendingorder"),
        "5": this.$t("processed.Orderincome"),
        "6": this.$t("processed.expenditure"),
        "7": this.$t("processed.Receiptentry"),
        "8": this.$t("processed.handlingexpenses"),
        "9": this.$t("processed.Returnincome"),
        "10": this.$t("processed.rentalexpenses"),
        "11": this.$t("processed.rentalincome"),
        "12": this.$t("processed.freightexpenses"),
        "13": this.$t("processed.revenue"),
        "14": this.$t("processed.Preferentia"),
        "15": this.$t("processed.Preferentialincome"),
        "16": this.$t("processed.SMSscore"),
        "17": this.$t("processed.SMSrevenue"),
        "18": this.$t("processed.Inventory"),
        "19": this.$t("processed.productincome"),
        "20": this.$t("processed.Customerexpenses"),
        "21": this.$t("processed.complaintrevenue"),
        "22": this.$t("processed.Smart"),
        "23": this.$t("processed.Revenueservice"),
        "24": this.$t("processed.Spendingtranslation"),
        "25": this.$t("processed.Translationincome"),
        "26": this.$t("processed.Logisticsexpenses"),
        "27": this.$t("processed.Logisticsfee"),
        "28": this.$t("processed.Cashspending"),
        "29": this.$t("processed.Cashbackincome"),
        "30": this.$t("processed.Cashspendings"),
        "31": this.$t("processed.Cashincome"),
        "32": this.$t('other.a807'),
        "33": this.$t('other.a807'),
        "34": this.$t('other.a807'),
        "35": this.$t('other.a807'),
        "36": this.$t('other.a807'),
        "37": this.$t('other.a807'),
        "38": this.$t('other.a807'),
        "38": this.$t('other.a807'),
        "39": this.$t('other.a1811'),
        "40": this.$t('other.a1812'),
        "41": this.$t('other.a1813'),
        "42": this.$t('other.a1813'),
        "43": this.$t('other.a1814'),
        "44": this.$t('other.a1815')
      },
      integralData: [],
      chartstaus: false,
      days: "", //要生成折线图天数
      gather: [], //广告费数据
      gathert: [], //已付款订单金额
      gatherthr: [], //出库商品所占头程费
      gatherfo: [], //出库商品所占采购成本
      gathertfiv: [], //已付款订单数
      entimedate: [],
      turnover: "",
      deliveryfee: "",
      orderItemCount: "",
      advCost: "",

      housevalue: "",
      profit: "",
      interest: "",
      inventoryData: [], //kucun
      originaldata: [], //原始数据
      warehouseSales: [],
      tableData: [],
      input: "",
      dialogVisible_hy: false,
      country: "",
      currency: "",
      rate: "",
      tabletype: {
        ID: this.$t("login.id"),
        MY: this.$t("login.my"),
        PH: this.$t("login.ph"),
        SG: this.$t("login.sg"),
        TH: this.$t("login.th"),
        TW: this.$t("login.tw"),
        VN: this.$t("login.vn")
      },
      dialogVisible_dd: false,
      newAuthorizedData: [],
      warehouselist: JSON.parse(localStorage.getItem("warehouse")) || " ",
      shopeeShoplist: JSON.parse(localStorage.getItem("shopIdInfo")) || " ",
      shophasAuthorization: JSON.parse(
        localStorage.getItem("shophasAuthorization")
      ),
      strorIdList: JSON.parse(localStorage.getItem("userInfo")).shopIds,
      chartsline: null,
      onlyStoreItem: false,
      claimdatatype: null,
      salesVisible: false,
      salesVisible01: false,
      value4: "",
      Claimpopup: false,
      allshopId: [],
      showPage: false,
      pointsInfomation: [],
      pointsInfomationNum: 0,
      setPassword: false,
      SecondPWSVisible: false,
      secondPws: "",
      shopName: "",
      kilogram: "",
      storeName: "",
      days01: null,
      pickerOptions2: {
        shortcuts: [
          {
            text: this.$t('other.a130'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: this.$t('other.a131'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: this.$t('other.a132'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },

  computed: {
    ...mapState({
      userId: state => state.login.userInfo.userId || "",
      warehouse: state => state.shopaccess.warehouse || "",
      userPos: state => state.login.userInfo.userPos || "",
      hasSecPw: state => state.login.userInfo.hasSecPw || "",
      Successed: state => state.shopaccess.Successed,
      sistemAllstore: state => state.shopaccess.sistemAllstore,
      lazadashopinfo: state => state.shopaccess.lazadashopinfo,
      allShopSales: state => state.shopaccess.allShopSales,
      allWarehouseSales: state => state.shopaccess.allWarehouseSales,
      allStoreCargovalue: state => state.shopaccess.allStoreCargovalue,
      allshipCostAmount: state => state.shopaccess.allshipCostAmount,
      salestotal: state => state.shopaccess.salestotal,
      salesquentity: state => state.shopaccess.salesquentity,
      cost: state => state.shopaccess.cost,
      shopSales: state => state.shopaccess.shopSales,
      toComfirmClaimtotal: state => state.shopaccess.toComfirmClaimtotal,
      Claimtotal: state => state.shopaccess.Claimtotal,
      hasClaimtotal: state => state.shopaccess.hasClaimtotal,
      Amount01: state => state.shopaccess.Amount01,
      Amount02: state => state.shopaccess.Amount02,
      Amount03: state => state.shopaccess.Amount03,
      secondPassword: state => state.shopaccess.secondPassword
    }),

    show() {
      if (this.hasSecPw) {
        return this.secondPassword;
      } else {
        return true;
      }
    },
    allStoreCargovalueCopy() {
      return this.allStoreCargovalue.toFixed(2);
    },

    salestotal01() {
      return this.salestotal.toFixed(2);
    },
    grossprofit() {
      let oop = this.salestotal - this.cost;
      return oop.toFixed(2);
    },
    //毛利率
    grossmargin() {
      let ttp = (this.salestotal - this.cost) / this.salestotal;
      let ccp = ttp * 100;
      return ccp ? ccp.toFixed(2) + "%" : "0";
    },
    //运输费用
    Transportation() {
      let ccp = this.allshipCostAmount;
      return ccp.toFixed(2);
    }
  },
  components: {
    Inventory
  },
  created() {
    // this.otnmgv()
    this.init();
    // this.getCargovalueByStore()
    // this.getOpp()
    this.getDaysBetween();
    this.getClaim();
    this.getPonit();
    this.getshopinfo();
    this.getstore();
    this.getshopsh();
    this.getintegralAll();
    // console.log(this.strorIdList);
  },
  mounted() {
    // this.setEchart();
    JsBarcode("#barcode", "1234", {
      //   format: "pharmacode",  //条形码的格式
      lineColor: "#000", //线条颜色
      width: 4, //线宽
      height: 40, //条码高度
      displayValue: false //是否显示文字信息
    });
  },
  methods: {
    ...mapActions("shopaccess", [
      "getShopSale",
      "getStoreSale",
      "getCargovalueStore",
      "getReturnOrder",
      "getLockShopID",
      "verifySecondyPassword",
      "getSellerPoint"
    ]),
    ...mapActions("userStoreItems", ["getStockRemind"]),
    ...mapActions("recharge", [
      "createPayorderBywechat",
      "OrderTracking",
      "pointChange",
      "getSellerPoint"
    ]),

    ...mapMutations("shopaccess", ["GET_TTO_CCP", "RESET_SECOND_PASSWORD"]),

    getStockRemindCopy() {
      new Promise((resolve, reject) => {
        this.getStockRemind({
          userId: this.userId,
          storeId: this.storeId
        }).then(res => {
          console.log("852", res);
          if (res.code == 200) {
            this.remindData = res.data;
            this.unsalable = res.data.filter(k => {
              if (k.unsalable) {
                return k;
              }
            });

            console.log(this.unsalable);
            let arr = res.data.filter(p => {
              p.salesAvg01 = Number(p.salesAvg.toFixed(2));
              p.needStock01 = p.dayOfShip * 2 * p.salesAvg01 - p.nowStock;
              return p;
            });
            let list = arr.filter(p => {
              if (p.storeItem.storeId === this.storeId && p.needStock01 > 0) {
                return p;
              }
            });
            resolve(list);
          }
        });
      }).then(res => {
        res.forEach(i => {
          i.needStock01 = Math.ceil(i.needStock01);
          i.salesAvg01 = Math.ceil(i.salesAvg01);
        });
        this.outOfstockReminderAmont = res.length;
        this.outOfstockReminder = res;
        console.log("缺货提醒11", res);
      });
    },

    ingknv() {
      // window.open(`/remote/remote.html`)
    },
    openmessage() {
      this.servie = true;
    },
    matchingnum(num) {
      let age = Math.abs(num);

      return age;
    },
    //计算天数差的函数，通用
    DateDiff(sDate1, sDate2) {
      //sDate1和sDate2是2006-12-18格式
      var aDate, oDate1, oDate2, iDays;
      aDate = sDate1.split("-");
      oDate1 = new Date(aDate[1] + "-" + aDate[2] + "-" + aDate[0]); //转换为12-18-2006格式
      aDate = sDate2.split("-");
      oDate2 = new Date(aDate[1] + "-" + aDate[2] + "-" + aDate[0]);
      iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24); //把相差的毫秒数转换为天数
      return iDays;
    },
    chartopen(index, row) {
      console.log(row);
      console.log(this.DateDiff(this.value4[0], this.value4[1])); //计算天数
      this.days = this.DateDiff(this.value4[0], this.value4[1]);
      console.log(this.days);
      let shopid = row.shopId;
      console.log(shopid);
      console.log(this.originaldata);
      let arrs = []; //shopee广告费
      let turnover = []; //已付款订单金额
      let shipCost = [];
      let costCount = [];
      let residue = [];
      let entime = [];
      for (let i = 0; i < this.originaldata.length; i++) {
        if (this.originaldata[i].shopId == shopid) {
          arrs.push(Math.abs(this.originaldata[i].advCost));
          turnover.push(this.originaldata[i].turnover);
          shipCost.push(this.originaldata[i].shipCost.toFixed(2));
          costCount.push(this.originaldata[i].costCount.toFixed(2));
          residue.push(
            this.originaldata[i].orderCount - this.originaldata[i].cancelCount
          );
          entime.push(
            this.renderTime(this.originaldata[i].createTime).substring(5, 10)
          );
        }
      }
      console.log(entime);
      console.log(turnover);
      console.log(arrs);
      console.log(residue);
      this.entimedate = entime;
      this.gather = arrs;
      this.gathert = turnover;
      this.gatherthr = shipCost;
      this.gatherfo = costCount;
      this.gathertfiv = residue;
      // this.one = row.advCost.toFixed(2);
      // this.two = row.cancelCount;
      // this.three = row.orderCount;
      // this.four = row.orderItemCount;
      // this.five = row.outboundCount;
      // this.six = row.shipCost.toFixed(2);
      // this.seven = row.turnover.toFixed(2);
      console.log(this.value4);
      setTimeout(() => {
        this.setEchart();
      }, 1000);
      this.chartstaus = true;
    },
    chartstauscolse() {
      this.chartstaus = false;
    },
    handleClose_hy() {
      this.dialogVisible_hy = false;
      this.activeData = [];
    },

    getnum(integral) {
      var num = integral;
      if (typeof num == "undefined") {
        return num;
      } else {
        return Number(num).toFixed(2);
      }
    },
    setEchart() {
      var chartDom = document.getElementById("categoryPortraitEchart");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        title: {
          // text: '商店走势'
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: [
            "Shopee广告费",
            "已付款订单金额",
            "出库商品所占头程费",
            "出库商品所占采购成本",
            "已付款订单数"
          ]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "Shopee广告费",
            type: "line",
            // stack: '总量',
            data: []
          },
          {
            name: "已付款订单金额",
            type: "line",
            // stack: '总量',
            data: []
          },
          {
            name: "出库商品所占头程费",
            type: "line",
            // stack: '总量',
            data: []
          },
          {
            name: "出库商品所占采购成本",
            type: "line",
            // stack: '总量',
            data: []
          },
          {
            name: "已付款订单数",
            type: "line",
            // stack: '总量',
            data: []
          }
        ]
      };
      let arr = [];
      for (let i = 1; i < this.days; i++) {
        arr.push(i);
      }
      console.log(arr);
      option.series[0].data = this.gather;
      option.series[1].data = this.gathert;
      option.series[2].data = this.gatherthr;
      option.series[3].data = this.gatherfo;
      option.series[4].data = this.gathertfiv;
      option.xAxis.data = this.entimedate;
      option && myChart.setOption(option);
    },

    echartsinter() {
      var chartDom = document.getElementById("main");
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        title: {
          text: "积分收入支出概况",

          left: "center"
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "vertical",
          left: "left"
        },
        series: [
          {
            name: "详情",
            type: "pie",
            radius: "50%",
            data: [
              { value: 1048, name: "订单支出" },
              { value: 735, name: "入库单支出" },
              { value: 580, name: "仓租费支出" },
              { value: 484, name: "优惠收入" },
              { value: 300, name: "短信积分支出" }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      };
      // var arr = [];
      // for(let i =0;i<this.integralData.length;i++){
      // 	arr.push(this.integralData[i].payType);
      // }
      // console.log(arr);

      option && myChart.setOption(option);
    },
    getstore() {
      api
        .getstoresta({
          userId: this.userId
        })
        .then(res => {
          this.warehouseSales = res.data;
          let housevalue = this.warehouseSales.reduce((pre, cur) => {
            return pre + cur.COST;
          }, 0);
          this.housevalue = housevalue.toFixed(2);
          console.log(res);
        });
    }, //获取仓库库存状态
    getshopsh() {
      api
        .getshopsh({
          end: this.value4[1],
          start: this.value4[0],
          userId: this.userId,
          shopIds: this.strorIdList
        })
        .then(res => {
          const resa = new Map();
          this.originaldata = res.data;
          const arr = res.data;
          let arrs = arr.reduce((list, item) => {
            if (resa.has(item.shopId)) {
              resa.get(item.shopId).turnover += item.turnover;
              resa.get(item.shopId).advCost += Math.abs(item.advCost);
              resa.get(item.shopId).cancelCount += item.cancelCount;
              resa.get(item.shopId).costCount += item.costCount;
              resa.get(item.shopId).orderCount += item.orderCount;
              resa.get(item.shopId).orderItemCount += item.orderItemCount;
              resa.get(item.shopId).outboundCount += item.outboundCount;
              resa.get(item.shopId).rate += item.rate;
              resa.get(item.shopId).returnAmount += item.returnAmount;
              resa.get(item.shopId).returnCount += item.returnCount;
              resa.get(item.shopId).shipCost += item.shipCost;
            } else {
              let o = { ...item };
              list.push(o);
              resa.set(item.shopId, o);
            }

            return list;
          }, []);
          console.log(arrs);
          this.inventoryData = arrs;

          let totalScore = this.inventoryData.reduce((pre, cur) => {
            return pre + cur.shipCost;
          }, 0);
          let turnoverScore = this.inventoryData.reduce((pre, cur) => {
            return pre + cur.turnover;
          }, 0);

          let orderItemCount = this.inventoryData.reduce((pre, cur) => {
            return pre + cur.orderItemCount;
          }, 0);
          let advCost = this.inventoryData.reduce((pre, cur) => {
            return pre + cur.advCost;
          }, 0);

          this.advCost = advCost;
          this.orderItemCount = orderItemCount;
          this.turnover = turnoverScore.toFixed(2);
          this.deliveryfee = totalScore.toFixed(2);
          this.profit = turnoverScore - totalScore - advCost;
          this.interest = (this.profit / this.turnover) * 100;
          this.inventoryData.forEach(p => {
            p.Tol_PerforMancd = {
              escrowAmount: p.orderCount - p.cancelCount
            };
          });
          console.log(this.inventoryData);
          console.log(turnoverScore);
          console.log(totalScore); //输出330
          console.log(res);
        });
    }, //获取商店销售
    getintegralAll() {
      api
        .getintegral({
          end: this.value4[1],
          start: this.value4[0],
          userId: this.userId
        })
        .then(res => {
          this.integralData = res.data;
          //   this.echartsinter();
          console.log(res);
        });
    }, //获取积分收入支出概况
    closedis() {
      api
        .updatecurrency({
          country: this.country,
          currency: this.currency,
          rate: this.input,
          userId: this.userId
        })
        .then(res => {
          console.log(res);
          if (res.code === 200) {
            this.$message({
              message: this.$t('other.a1816'),
              type: "success"
            });
            this.input = "";
            this.getshopinfo();
            this.dialogVisible_hy = false;
          }
        });
    },
    renderTime(date) {
      var dateee = new Date(date).toJSON();
      return new Date(+new Date(dateee) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, " ")
        .replace(/\.[\d]{3}Z/, "");
    },
    closedisid() {
      this.dialogVisible_hy = false;
    },
    handleEdit(index, row) {
      console.log(index, row);
      this.country = row.country;
      this.currency = row.currency;
      this.rate = row.rate;
      this.input = row.rate;
      this.dialogVisible_hy = true;
    },
    openexch() {
      this.dialogVisible_dd = true;
    },
    handleClose_dd() {
      this.dialogVisible_dd = false;
    },
    getshopinfo() {
      api
        .getcurrencyall({
          userId: this.userId
        })
        .then(res => {
          this.tableData = res.data;
          console.log("利率", res);
        });
    },

    getPonit() {
      this.getSellerPoint({
        userId: this.userId
      });
    },
    setSecondPWS() {
      api
        .setSecPws({ userId: this.userId, password: this.secondPws })
        .then(res => {
          if (res.code == 200) {
            this.$confirm(this.$t('other.a1817'), this.$t('other.a142'), {
              confirmButtonText: this.$t('other.a729'),
              type: "success"
            }).then(() => {
              this.SecondPWSVisible = false;
              let obj = JSON.parse(localStorage.getItem("userInfo"));
              obj.hasSecPw = true;
              localStorage.setItem("userInfo", JSON.stringify(obj));
              location.reload();
            });
          } else {
            this.$message.error(res.msg);
          }
        });
    },

    f1() {
      let promise = new Promise((resovle, reject) => {
        let num = Math.random() * 6;
        setTimeout(() => {
          resovle(num);
        }, 1000);
      });
      return promise;
    },
    async f2() {
      let T = null;
      let n = await this.f1();
      console.log(n);
      console.log(T);
    },

    gotopersonal() {
      const { href } = this.$router.resolve({
        path: "/personal-account",
        query: {
          key: "resetSecondPws"
        }
      });
      window.open(href);
    },

    closePage() {
      localStorage.removeItem("secondPws");
      this.RESET_SECOND_PASSWORD();
      this.kilogram = "";
    },

    comfirm() {
      this.verifySecondyPassword({
        userAccount: this.userId,
        verifyPassword: this.kilogram
      });

      console.log(this.secondPassword);
    },

    returnCause(ttp) {
      const status = {
        LOST_PARCEL: this.$t('other.a114'),
        LOGISTICS_DELIVERY_FAILED: this.$t('other.a115')
      };
      return status[ttp];
    },

    otnmgv() {
      let newUrl = location.href;

      let arr = newUrl.split(/=/);
      let shopid = parseInt(arr[arr.length - 1]);
      console.log("shopid", shopid);
      const params = {
        userId: this.userId,
        shopId: shopid
      };
      console.log(params);

      if (newUrl.search("shop_id") == -1) {
        console.log(typeof shopid);
        return;
      } else {
        console.log(params);
        this.getLockShopID(params);
        this.$router.push("./index");
      }
    },

    //刷新页面
    updataPage() {
      this.getClaim();
    },
    //查看索赔的订单
    viewMore(num) {
      console.log(123);
      this.claimdatatype = num;
      this.Claimpopup = true;

      let arr = null;
      if (num === 0) {
        arr = {
          offset: 15,
          page: 0,
          shopIds: this.allshopId,
          type: 0,
          userId: this.userId
        };
      } else if (num === 1) {
        arr = {
          offset: 15,
          page: 0,
          shopIds: this.allshopId,
          type: 1,
          userId: this.userId
        };
      } else if (num === 2) {
        arr = {
          offset: 15,
          page: 0,
          shopIds: this.allshopId,
          type: 2,
          userId: this.userId
        };
      }
      this.getReturnOrder(arr);
    },
    //获取索赔的订单
    getClaim() {
      let arr = [
        {
          offset: 15,
          page: 0,
          shopIds: this.allshopId,
          type: 0,
          userId: this.userId
        },
        {
          offset: 15,
          page: 0,
          shopIds: this.allshopId,
          type: 1,
          userId: this.userId
        },
        {
          offset: 15,
          page: 0,
          shopIds: this.allshopId,
          type: 2,
          userId: this.userId
        }
      ];
      arr.forEach(p => {
        this.getReturnOrder(p);
      });
    },

    getSalesBytime() {
      console.log(this.value4);
      // this.getOpp()
      this.getshopsh(); //随时间进行查询
    },

    getSales() {
      console.log(this.onlyStoreItem);
      this.getOpp();
    },

    getCargovalueByStore() {
      let arr = this.warehouse.map(p => {
        return {
          storeId: p.storeId,
          userId: this.userId
        };
      });

      console.log(arr);
      arr.forEach(k => {
        this.getCargovalueStore(k);
      });
    },
    //匹配店铺名称  286652887-blackmore
    showshopNameByshopIdOne(id) {
      let obj = new Object();
      let shopList = utils.getAllshop().slice(1);
      shopList.forEach((p, index) => {
        obj[shopList[index].value] = p.label;
      });
      return obj[id];
    },
    getOpp() {
      this.GET_TTO_CCP();

      this.shopeeShoplist.forEach(p => {
        this.getShopSale({
          end: this.value4[1],
          start: this.value4[0],
          onlyStoreItem: this.onlyStoreItem,
          shopId: p.shopId,
          shopName: p.shopName,
          userId: this.userId
        });
      });

      // this.warehouse.forEach(k => {
      // 	this.getStoreSale({
      // 		end:this.value4[1],
      // 		start:this.value4[0],
      // 		userId:this.userId,
      // 		storeName:k.storeName,
      // 		storeId:k.storeId
      // 	})
      // })
    },
    getshopName(shopId) {
      // 		this.customgroup.filter(function(item){
      //         return item.categoryName == "黑名单";
      //   })

      let arr = this.shopeeShoplist.filter(p => {
        return p.shopId == shopId;
      });
    },

    init() {
      console.log(this.$refs.mark);
      let start = utils.getRecentSevenDay(-30);
      let end = utils.getRecentSevenDay(0);
      this.value4 = [start, end];

      let allshopId = utils.getAllshop().map(p => {
        return p.value;
      });

      let ttp = JSON.parse(localStorage.getItem("userInfo"));
      this.showPage = ttp.secondPassword;

      allshopId.splice(0, 1);
      this.allshopId = allshopId;
    },
    handleSizeChange(val) {
      this.pagesize = Number(`${val}`);
      console.log("每面显示的数量", this.pagesize);
      this.handleCurrentChange();
    },
    handleCurrentChange(val) {
      let num = Number(`${val}`);
      this.page = (num - 1) * this.pagesize;
      this.getRecharge();
    },

    getppc() {
      this.allShopSales.forEach(p => {
        if (p.shopName === this.shopName) {
          this.chartsline = echarts.init(
            document.getElementById(this.shopName)
          );

          this.chartsline.setOption(p.option);
        }
      });
    },
    getppc01() {
      this.allWarehouseSales.forEach(k => {
        if (k.storeName === this.storeName) {
          this.chartsline = echarts.init(
            document.getElementById(this.storeName)
          );
          this.chartsline.setOption(k.option);
        }
      });
    },
    //获取两个日期间 的天数
    getDaysBetween() {
      let ttp = this.value4[0];
      let ccp = this.value4[1];
      var startDate = Date.parse(ttp);
      var endDate = Date.parse(ccp);
      var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      this.days01 = days;
    },
    getSaleAVG(item) {
      let ttp = item.sales / this.days01;
      return ttp.toFixed(2);
    },
    gestoreAVG(item) {
      let ttp = item.sales / this.days01;
      return ttp.toFixed(2);
    },
    viewSales(item) {
      this.salesVisible = true;
      this.shopName = item.shopName;

      setTimeout(() => {
        this.getppc();
      }, 200);
    },
    viewSalesStore(item) {
      console.log(item);
      this.salesVisible01 = true;
      this.storeName = item.storeName;

      setTimeout(() => {
        this.getppc01();
      }, 200);
    }
  }
};
</script>

<style>
.home-box {
  background-color: rgba(50, 50, 50, 0.1);
  width: 99%;
}

.el-tooltip__popper {
  font-size: 16px !important;
}

.home-wrapper {
  flex: 1;
  margin: 50px 0 0 221px;
}

.home-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  background-color: #fff;

  margin-bottom: 10px;
  padding: 0 20px 0 0;
}

.home .jlknkg {
  display: flex;
  justify-content: space-around;
  padding: 10px;
}
.home .ilnkg {
  background-color: #fff;
  margin: 0 15px 20px 15px;
  border-radius: 5px;
}

.home .klnf {
  padding: 10px 0 5px 18px;
  font-weight: bold;
  color: #616066;
}

.home .lknl {
  padding-top: 15px;
  color: #919099;
  font-size: 14px;
}

.home .skilk {
  border-right: 2px dashed #ddd;
  padding: 20px;
}

.line-box {
  width: 700px;
  height: 300px;
  background-color: #fff;
  border-radius: 10px;
}

/* 	.home-wrapper{
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		margin-bottom: 20px;
	}
	 */
.home-box-ttp {
  display: flex;
  justify-content: space-around;
  padding: 10px;
  margin-bottom: 30px;
}

.edit-item {
  display: flex;
}

.warpper-box {
  display: flex;
  justify-content: center;
}

.home-box-item {
  width: 400px;
  height: 220px;
  font-size: 22px;
  background-color: #fff;
  border-radius: 10px;
  border: 1px solid #eee;
}

.home-box-item-childern {
  width: 400px;
  height: 100px;
  background-color: #fff;
  border-radius: 10px;
}
.home-box-item-childern-header {
  display: flex;
  justify-content: space-between;
  border-bottom: #eee 1px solid;
  align-items: center;
  height: 50px;
  line-height: 50px;
  box-sizing: border-box;
  padding: 0 10px;
}
/* .service-body{
		width: 120px;
		height: 80px;
		background: #ff751a;
		display: flex;
		color: #fff;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		position: fixed;
		top: 70%;
		right: 0%;
		z-index: 9999;
		cursor: pointer;
		border-radius: 20px;

	}
	.service-body:hover{
		background: #ff6600;
	}
	.service-mess{
		width: 450px;
		height: 500px;
		display: flex;
		background: #eee;
		align-items: flex-start;
		justify-content: flex-start;
		flex-direction: column;
		position: fixed;
		top: 30%;
		right: 10%;
		border-radius: 10px;
		z-index: 9999;
	} */
.ser-two {
  width: 450px;
  height: 300px;
  display: flex;
  background: #fff;
}
.ser-one-boy {
  width: 40px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  margin-right: 10px;
}
.ser-tit-one {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  /* background: chocolate; */
}
.ser-one-boy:hover {
  background: #0066ff;
}
.ser-one {
  width: 450px;
  height: 50px;
  display: flex;
  background: cornflowerblue;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
}
.ser-one-title {
  width: 300px;
  height: 60px;
  display: flex;
  margin-left: 10px;
  align-items: center;
  justify-content: flex-start;
  border-radius: 10px;
}
.home-box-item-childern-content {
  font-size: 18px;
  margin-top: 15px;
  box-sizing: border-box;
  padding: 0 10px;
}
.item-header {
  display: flex;
  justify-content: space-between;
  border-bottom: #eee 1px solid;
  align-items: center;
  height: 50px;
  line-height: 50px;
  box-sizing: border-box;
  padding: 0 10px;
}
.item-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100px;
  box-sizing: border-box;
  padding: 0 10px;
  border-bottom: #eee 1px solid;
}

.item-header-right {
  font-size: 14px;
  background-color: #008161;
  height: 30px;
  padding: 0 10px;
  color: #fff;
  line-height: 30px;
  border-radius: 5px;
  cursor: pointer;
}
.item-header-right01 {
  font-size: 16px;
  background-color: orange;
  height: 30px;
  padding: 0 10px;
  color: #fff;
  line-height: 30px;
  border-radius: 5px;
  margin-left: 5px;
}

.item-footer {
  box-sizing: border-box;
  padding: 0 10px;
}

.shop-sales {
  border-radius: 5px;
  box-sizing: border-box;
  padding: 0 10px 10px 10px;
  margin: 0 15px 30px 15px;

  background-color: #fff;
}
.sales-content-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px #eee solid;
}

.sales-content-title-item {
  display: inline-block;
  width: 190px;

  padding-bottom: 10px;
  text-align: center;
}
.sales-content-title-item:nth-child(1) {
  width: 250px;
}

.shop-sales-header {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-top: 10px;
}

.store-item {
  height: 60px;
  line-height: 60px;
}

/* 	.home .el-input__inner{
		width: 170px;
		border: none!important;
	}
	.home .el-input--mini{
		width: 170px!important;
	} */
</style>
